import { render } from "./ImageButton.vue?vue&type=template&id=36453fd9"
import script from "./ImageButton.vue?vue&type=script&lang=js"
export * from "./ImageButton.vue?vue&type=script&lang=js"

import "./ImageButton.vue?vue&type=style&index=0&id=36453fd9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__